/* tslint:disable */
/* eslint-disable */
/**
 * Retool API
 * The Retool API is in beta. Go to Settings > API to get started. Once you generate an API token, use bearer token authentication to make requests.
 *
 * The version of the OpenAPI document: 2.4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Custom Component Library Revision
 * @export
 * @interface CustomComponentLibraryRevisionFile
 */
export interface CustomComponentLibraryRevisionFile {
    /**
     * 
     * @type {string}
     * @memberof CustomComponentLibraryRevisionFile
     */
    filepath: string;
    /**
     * 
     * @type {string}
     * @memberof CustomComponentLibraryRevisionFile
     */
    fileContents: string;
    /**
     * 
     * @type {Date}
     * @memberof CustomComponentLibraryRevisionFile
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof CustomComponentLibraryRevisionFile
     */
    updatedAt: Date;
}

/**
 * Check if a given object implements the CustomComponentLibraryRevisionFile interface.
 */
export function instanceOfCustomComponentLibraryRevisionFile(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "filepath" in value;
    isInstance = isInstance && "fileContents" in value;
    isInstance = isInstance && "createdAt" in value;
    isInstance = isInstance && "updatedAt" in value;

    return isInstance;
}

export function CustomComponentLibraryRevisionFileFromJSON(json: any): CustomComponentLibraryRevisionFile {
    return CustomComponentLibraryRevisionFileFromJSONTyped(json, false);
}

export function CustomComponentLibraryRevisionFileFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomComponentLibraryRevisionFile {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'filepath': json['filepath'],
        'fileContents': json['file_contents'],
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
    };
}

export function CustomComponentLibraryRevisionFileToJSON(value?: CustomComponentLibraryRevisionFile | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'filepath': value.filepath,
        'file_contents': value.fileContents,
        'created_at': (value.createdAt.toISOString()),
        'updated_at': (value.updatedAt.toISOString()),
    };
}

